<div *ngIf="formField != undefined && formField.invalid && (formField.dirty || formField.touched)" class="alert-danger">
  <section *ngFor="let validator of definition.validation">
    <p *ngIf="formField.errors[validator.key]">{{validator.message}}</p></section>
</div>
